// 新資料把既有 evas2_lesion_name 維持為舊版可直接顯示的純病灶文字；
// 完整 typed lesion/intervention 順序走 API 投影的 sidecar。PREFIX 只用來讀已產生的舊資料，
// 新 writer 不再產生 envelope，確保 rolling deploy／rollback 不露出協定字串。
const PREFIX = '@EVAS2A1|'
const CATEGORY_CODE = { lesion: 'L', intervention: 'I' }
const CODE_CATEGORY = { L: 'lesion', I: 'intervention' }

function cleanEntry(entry) {
  const category = String(entry && entry.category || '')
  const term = String(entry && entry.term || '').trim()
  if (!CATEGORY_CODE[category] || !term) return null
  return { category, term }
}

function uniqueEntries(entries) {
  const result = []
  for (const entry of (Array.isArray(entries) ? entries : []).map(cleanEntry).filter(Boolean)) {
    if (!result.some((existing) => (
      existing.category === entry.category && existing.term.toLowerCase() === entry.term.toLowerCase()
    ))) result.push(entry)
  }
  return result
}

function replaceLesionInOrder(entries, lesionName) {
  const lesion = String(lesionName || '').trim()
  const result = []
  let inserted = false
  for (const entry of uniqueEntries(entries)) {
    if (entry.category === 'lesion') {
      if (lesion && !inserted) {
        result.push({ category: 'lesion', term: lesion })
        inserted = true
      }
      continue
    }
    result.push(entry)
  }
  // intervention-only sidecar 沒有可沿用的 lesion 位置；舊 reader 的純文字欄原本
  // 就先顯示病灶，因此補在最前面，維持 rolling/rollback 的閱讀順序。
  if (lesion && !inserted) result.unshift({ category: 'lesion', term: lesion })
  return uniqueEntries(result)
}

export function parseClinicalAnnotations(value, sidecar = []) {
  const text = String(value || '').trim()
  const stored = !text
    ? []
    : !text.startsWith(PREFIX)
      ? [{ category: 'lesion', term: text }]
      : text.slice(PREFIX.length).split('|').map((part) => {
    const match = part.match(/^([LI]):(.*)$/)
    if (!match) return null
    try {
      return cleanEntry({ category: CODE_CATEGORY[match[1]], term: decodeURIComponent(match[2]) })
    } catch (_) {
      return null
    }
  }).filter(Boolean)
  const projected = uniqueEntries(sidecar)
  if (text.startsWith(PREFIX)) return uniqueEntries([...stored, ...projected])

  // 純文字欄是所有舊 reader/API 都能讀到的 lesion authority。sidecar 只保留型別與
  // 跨類別順序；即使它殘留舊 lesion，也要以欄位新值同步替換或移除。
  return replaceLesionInOrder(projected, text)
}

export function serializeClinicalAnnotations(entries) {
  const clean = (Array.isArray(entries) ? entries : []).map(cleanEntry).filter(Boolean)
  return firstLesion(clean)
}

export function interventionAnnotations(entries) {
  return (Array.isArray(entries) ? entries : [])
    .map(cleanEntry)
    .filter((entry) => entry && entry.category === 'intervention')
}

export function firstLesion(entries) {
  const hit = (Array.isArray(entries) ? entries : []).find((entry) => entry.category === 'lesion')
  return hit ? hit.term : ''
}

export function clinicalAnnotationText(entries) {
  return (Array.isArray(entries) ? entries : []).map((entry) => entry.term).filter(Boolean).join(' · ')
}

export function replaceClinicalLesion(value, lesionName, sidecar = []) {
  const lesion = String(lesionName || '').trim()
  return {
    lesionName: lesion,
    annotations: replaceLesionInOrder(parseClinicalAnnotations(value, sidecar), lesion),
  }
}
